import classNames from 'classnames';

import styles from '../../styles/typography/body.module.css';

interface BodyProps {
    children?: React.ReactNode;
    theme?: 'quatre95' | 'periodelibre' | 'dehors' | 'france' | 'mollo' | null;
    inherit?: boolean;
    className?: string | null;
    onClick?: () => void;
}

function Body({
    children,
    theme = null,
    inherit = false,
    className = null,
    onClick = null,
}: BodyProps) {
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles.inherit]: inherit,
                },
                className,
            ])}
            data-theme={theme}
            onClick={onClick}
        >
            {children}
        </div>
    );
}

export default Body;
